<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
        <div class="p-formgrid p-grid p-justify-center">
          <div class="p-field p-col-12 p-lg-4 p-mb-3">
            <label for="keyword">{{ $t("keyword") }}</label>
            <InputText id="suggest_keyword" type="text" v-model="keyword" />
          </div>
          <div class="p-field p-col-12 p-lg-4 p-mb-3">
            <label for="suggestion_receiveDate">วันที่เริ่มต้น</label>
            <!-- <label for="suggestion_receiveDate">{{ $t("receiveDate") }}</label> -->
            <Calendar
              dateFormat="dd/mm/yy"
              :maxDate="suggestion_toDate"
              :showButtonBar="true"
              :monthNavigator="true"
              :yearNavigator="true"
              yearRange="2000:2050"
              :locale="th"
              id="suggestion_receiveDate"
              v-model="suggestion_receiveDate"
            ></Calendar>
          </div>
          <div class="p-field p-col-12 p-lg-4 p-mb-3">
            <label for="suggestion_toDate">วันที่สิ้นสุด</label>
            <!-- <label for="suggestion_toDate">{{ $t("toDate") }}</label> -->
            <Calendar
              dateFormat="dd/mm/yy"
              :minDate="suggestion_receiveDate"
              :showButtonBar="true"
              :monthNavigator="true"
              :yearNavigator="true"
              yearRange="2000:2050"
              :locale="th"
              id="suggestion_toDate"
              v-model="suggestion_toDate"
            ></Calendar>
          </div>
          <div class="p-field p-col">
            <div class="p-formgrid p-grid p-jc-end p-mt-5">
              <Button
                @click="clearSearchField()"
                :label="$t('clearBtn')"
                class="p-button-clear p-ml-3 p-mr-3 p-mt-2"
              />
              <Button
                @click="searchSuggest()"
                :label="$t('searchBtn')"
                class="p-button-info p-mt-2"
              />
            </div>
          </div>
        </div>
      </div>
    </Fieldset>

    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="suggestion_table"
        :paginator="true"
        class="p-datatable-customers" 
        :rows="10"
        dataKey="id"
        :rowHover="true"
        :selection.sync="selectedSuggestion"
        :filters="filters"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class=" ">
            <div class="table-header"  style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column field="date" :header="$t('suggest_date')" :sortable="true">
          <template #body="dataTable">
            <span class="p-column-title">{{ $t('suggest_date') }}</span>
            <div hidden>{{ dataTable.data.suggest_id }}</div>
            {{ dataTable.data.date }}
            
          </template>
        </Column>
        
        <Column
          field="suggest_name"
          :header="$t('suggest_name')"
          :sortable="true"
        >
          <template #body="dataTable">
            <span class="p-column-title">{{ $t('suggest_name') }}</span>
            {{ dataTable.data.suggest_name }}
          </template>
        </Column>
        <Column
          field="suggest_topic"
          :header="$t('suggest_topic')"
          :sortable="true"
        >
          <template #body="dataTable">
            <span class="p-column-title">{{ $t('suggest_topic') }}</span>
            {{ dataTable.data.suggest_topic }}
          </template>
        </Column>
        <Column
          field="suggest_detail"
          :header="$t('suggest_detail')"
          :sortable="true"
        >
          <template #body="dataTable">
            <span class="p-column-title">{{ $t('suggest_detail') }}</span>
            {{ dataTable.data.suggest_detail }}
          </template>
        </Column>
        <Column
          field="user_fullname"
          :header="$t('suggest_editor')"
          :sortable="true"
        >
          <template #body="dataTable">
            <span class="p-column-title">{{ $t('suggest_editor') }}</span>
            <div v-if="dataTable.data.user_fullname != null">
              {{ dataTable.data.user_fullname }}
            </div>
            <div v-else>
              -
            </div>
            
          </template>
        </Column>
        <Column :header="$t('suggest_readerStatus')" :headerStyle="{textAlign:'center'}">
          <template #body="dataTable">
            <div v-if="dataTable.data.suggest_status == '1'" class="table_row">
              <i class="pi pi-check"></i>
            </div>
            <div v-else><i class="pi pi-times"></i></div>
          </template>
        </Column>
        <Column :header="$t('controlTable')" v-if="checkEdit_data != 'false' || checkDelete_data != 'false' "
        :headerStyle="{textAlign:'center'}">
          <template #body="dataTable">
            <span class="p-column-title">{{ $t('controlTable') }}</span>
            <div class="p-formgrid p-grid">
              <div class="p-field p-col p-mb-1" v-if="checkEdit_data != 'false'">
                <Button
                  @click="checkPermissionEdit(dataTable.data.suggest_id)"
                  icon="pi pi-pencil"
                  :label="$t('editBtn')"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div class="p-field p-col p-mb-1" v-if="checkDelete_data != 'false'">
                <Button
                  @click="checkPermissionDelete(dataTable.data.suggest_id)"
                  icon="pi pi-trash"
                  :label="$t('deleteBtn')"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Edit suggestion modal -->
    <Dialog
      :modal="true"
      :visible.sync="suggestionModal"
      :style="{ width: '700px' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :header="$t('suggestion_modal_title_edit')"
    >
      <div class="confirmation-content" >
        <label>{{ $t("suggestion_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-5">
          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="suggest_date">{{ $t("suggest_date") }}</label>
              <Calendar
                dateFormat="dd/mm/yy"
                :showButtonBar="true"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2050"
                :locale="th"
                id="suggest_date"
                v-model="suggest_date"
                disabled
              ></Calendar>
            </div>
            <div class="p-field p-col"></div>
          </div>
          <div class="p-formgrid p-grid p-mt-3">
            <div class="p-field p-col">
              <label for="suggest_name">{{ $t("suggest_name") }}</label>
              <InputText
                id="suggest_name"
                type="text"
                v-model="suggest_name"
                disabled
              />
            </div>
            <div class="p-field p-col">
              <label for="suggest_email_phone">{{
                $t("suggest_email_phone")
              }}</label>
              <InputText
                id="suggest_email_phone"
                type="text"
                v-model="suggest_email_phone"
                disabled
              />
            </div>
          </div>
          <div class="p-fluid">
            <div class="p-field p-mt-3">
              <label for="suggest_topic">{{ $t("suggest_topic") }}</label>
              <InputText
                id="suggest_topic"
                type="text"
                v-model="suggest_topic"
                disabled
              />
            </div>
            <div class="p-field p-mt-3">
              <label for="suggest_detail">{{ $t("suggest_detail") }}</label>
              <Textarea
                id="suggest_detail"
                type="text"
                rows="5"
                v-model="suggest_detail"
                disabled
              />
            </div>
          </div>
          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="suggest_reply">{{ $t("suggest_reply") }}</label>
              <Textarea
                id="suggest_reply"
                type="text"
                rows="5"
                v-model="suggest_reply"
                autofocus
              />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="suggestionModal = false"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveSuggestion()"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete(temp)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {

      checkRole:null,
      checkView_data:null,
      checkAdd_data:null,
      checkEdit_data:null,
      checkDelete_data:null,


      keyword: "",
      suggestion_receiveDate: null,
      suggestion_toDate: null,
      selectedSuggestion: null,
      suggestion_table: [],
      filters: {},
      temp: null,
      displayConfirmation: false,
      suggestionModal: false,
      selectedData: "",
      suggest_date: "",
      suggest_name: "",
      suggest_email_phone: "",
      suggest_topic: "",
      suggest_detail: "",
      suggest_reply: "",
      suggest_disable: true,
    };
  },
  watch: {
    suggestion_receiveDate(val) {
      if (val == null) {
        this.suggestion_toDate = null;
      }
    },
  },
  created() {
    this.initialData();
    this.checkRole = JSON.parse(localStorage.getItem("data")).permission_id;
    this.checkView_data = JSON.parse(localStorage.getItem("data")).view_data;
    this.checkAdd_data = JSON.parse(localStorage.getItem("data")).add_data;
    this.checkEdit_data = JSON.parse(localStorage.getItem("data")).edit_data;
    this.checkDelete_data = JSON.parse(localStorage.getItem("data")).delete_data;
  },
  mounted() {},
  methods: {
    async checkPermissionEdit(suggest_id) {
      if (this.suggest_disable == false) {
        this.suggestionModal = true;
        this.editData(suggest_id);
        this.temp = suggest_id;
      } else {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "เกิดข้อผิดพลาด",
        //   detail: "คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล",
        //   life: 10000,
        // });

        this.$fire({
          title: "คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล",
          // text: "คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล",
          type: "warning",
          timer: 10000,
          confirmButtonColor: '#28B463',
        });
      }
    },
    async checkPermissionDelete(suggest_id) {
      if (this.suggest_disable == false) {
        this.displayConfirmation = true;
        this.temp = suggest_id
      } else {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "เกิดข้อผิดพลาด",
        //   detail: "คุณไม่มีสิทธิ์ในการลบข้อมูล",
        //   life: 10000,
        // });
         this.$fire({
          title: "คุณไม่มีสิทธิ์ในการลบข้อมูล",
          // text: "คุณไม่มีสิทธิ์ในการลบข้อมูล",
          type: "warning",
          timer: 10000,
          confirmButtonColor: '#28B463',
        });
      }
    },
    async initialData() {
      this.filters={}
      let temporary = localStorage.getItem("username");
      if ((temporary.toString().indexOf("manage03") != -1) || temporary.toString().indexOf("manage032") != -1) {
        this.suggest_disable = false;
      } else {
        this.suggest_disable = true;
      }

      await this.axios
        .post(`${this.$url_service}/get/suggestion`, {
          body: {
            topic: "get-table",
          },
        })
        .then((response) => {
          this.suggestion_table = response.data.data;
          // console.log("this.suggestion_table",this.suggestion_table)
          // แก้ไขเวลา
          // for (let index = 0; index < this.suggestion_table.length; index++) {
          //   const element = this.suggestion_table[index].date.split("/")
            
          //   let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`)
          //   // console.log("dateNew",dateNew)
          //   this.suggestion_table[index].date = moment(dateNew).locale('th').add(543, 'year').format("l")
          // }

        });
    },
    async searchSuggest() {
      this.filters={}
      var start_date, to_date;
      if (this.suggestion_receiveDate != null) {
        const receive = new Date(this.suggestion_receiveDate);
        const ye1 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          receive
        );
        const mo1 = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          receive
        );
        const da1 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          receive
        );
        start_date = `${ye1}-${mo1}-${da1}`;
      }
      if (this.suggestion_toDate != null) {
        const to = new Date(this.suggestion_toDate);
        const ye2 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          to
        );
        const mo2 = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          to
        );
        const da2 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          to
        );
        to_date = `${ye2}-${mo2}-${da2}`;
      }
      await this.axios
        .post(`${this.$url_service}/get/suggestion`, {
          body: {
            topic: "search-table",
            keyword: this.keyword,
            receive_date: start_date,
            to_date: to_date,
          },
        })
        .then((response) => (this.suggestion_table = response.data.data));
    },

    async editData(data) {
      await this.axios
        .post(`${this.$url_service}/get/suggestion`, {
          body: {
            topic: "showone-suggestion",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedData = response.data.data),
            (this.suggest_date = response.data.data.date),
            (this.suggest_name = response.data.data.suggest_name),
            (this.suggest_email_phone = response.data.data.suggest_contact),
            (this.suggest_topic = response.data.data.suggest_topic),
            (this.suggest_detail = response.data.data.suggest_detail),
            (this.suggest_reply = response.data.data.suggest_reply);
        });
    },

    async saveSuggestion() {
      await this.axios
        .post(
          `${this.$url_service}/get/suggestion?user=${this.getUsername()}`,
          {
            body: {
              topic: "edit-suggestion",
              id: this.temp,
              reply: this.suggest_reply,
              editor: JSON.parse(localStorage.getItem("data")).user_id,
            },
          }
        )
        .then(() => this.initialData());
      this.suggestionModal = false;
    },

    async confirmDelete(data) {
      await this.axios
        .post(
          `${this.$url_service}/get/suggestion?user=${this.getUsername()}`,
          {
            body: {
              topic: "delete-suggestion",
              id: this.temp,
            },
          }
        )
        .then(() => this.initialData());
      this.displayConfirmation = false;
      console.log(`Delete ${data} finish!`);
    },

    async clearSearchField() {
      this.filters={}
      await this.axios
        .post(`${this.$url_service}/get/suggestion`, {
          body: {
            topic: "get-table",
          },
        })
        .then((response) => {
          // console.log(response.data),
            (this.suggestion_table = response.data.data);
        });
      this.suggestion_receiveDate = null;
    },
  },
};
</script>

<style scoped>
  .table_row{
  text-align: center;
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}


</style>


<style scoped lang="scss">
@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
  /deep/ .p-progressbar {
    height: .5rem;
    background-color: #D8DADC;
  
    .p-progressbar-value {
      background-color: #607D8B;
    }
  }
  
  .p-datatable .p-column-filter {
    display: none;
  }
  
  .table-header {
    display: flex;
    justify-content: space-between;
    min-width: 10rem;
    max-width: 15rem;
  }
  
  /deep/ .p-datatable.p-datatable-customers {
    .p-datatable-header {
      padding: 1rem;
      text-align: left;
      font-size: 1.5rem;
    }
  
    .p-paginator {
      padding: 1rem;
    }
  
    .p-datatable-thead > tr > th {
      text-align: left;
    }
  
    .p-datatable-tbody > tr > td {
      cursor: auto;
    }
  
    .p-dropdown-label:not(.p-placeholder) {
      text-transform: uppercase;
    }
  }
  
  /* Responsive */
  .p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    display: none;
  }
  
  .customer-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
  
    &.status-qualified {
      background: #C8E6C9;
      color: #256029;
    }
  
    &.status-unqualified {
      background: #FFCDD2;
      color: #C63737;
    }
  
    &.status-negotiation {
      background: #FEEDAF;
      color: #8A5340;
    }
  
    &.status-new {
      background: #B3E5FC;
      color: #23547B;
    }
  
    &.status-renewal {
      background: #ECCFFF;
      color: #694382;
    }
  
    &.status-proposal {
      background: #FFD8B2;
      color: #805B36;
    }
  }
  
  .p-progressbar-value.ui-widget-header {
    background: #607d8b;
  }
  
  @media (max-width: 640px) {
    .p-progressbar {
      margin-top: .5rem;
    }
  }
  
  .product-image {
    width: 100px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
  }
  
  .orders-subtable {
    padding: 1rem;
  }
  
  .product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
  
    &.status-instock {
      background: #C8E6C9;
      color: #256029;
    }
  
    &.status-outofstock {
      background: #FFCDD2;
      color: #C63737;
    }
  
    &.status-lowstock {
      background: #FEEDAF;
      color: #8A5340;
    }
  }
  
  .order-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
  
    &.order-delivered {
      background: #C8E6C9;
      color: #256029;
    }
  
    &.order-cancelled {
      background: #FFCDD2;
      color: #C63737;
    }
  
    &.order-pending {
      background: #FEEDAF;
      color: #8A5340;
    }
  
    &.order-returned {
      background: #ECCFFF;
      color: #694382;
    }
  }
  
  @media screen and (max-width: 960px) {
    /deep/ .p-datatable {
      &.p-datatable-customers {
        .p-datatable-thead > tr > th,
        .p-datatable-tfoot > tr > td {
          display: none !important;
        }
  
        .p-datatable-tbody > tr {
          border-bottom: 1px solid var(--layer-2);
  
          > td {
            text-align: left;
            display: block;
            border: 0 none !important;
            width: 100% !important;
            float: left;
            clear: left;
            border: 0 none;
  
            .p-column-title {
              padding: .4rem;
              min-width: 30%;
              display: inline-block;
              margin: -.4rem 1rem -.4rem -.4rem;
              font-weight: bold;
            }
  
            .p-progressbar {
              margin-top: .5rem;
            }
          }
        }
      }
    }
  }
  </style>
  
